<div
  [ngbPopover]="template"
  container="body"
  triggers="manual"
  popoverClass="event-popover-wrapper"
  class="d-flex align-items-center"
>
  <ng-content></ng-content>
</div>
